import { RootState } from 'store/types';
import { IAuth, IUserInfo } from 'store/slices/auth/types';

export const getAuthState = (state: RootState): IAuth => state.auth;
export const getAuthUserInfo = (state: RootState): IUserInfo | undefined => getAuthState(state).userInfo;
